module.exports = __webpack_public_path__ + "img/hero-lg.429519e.webp";